import isLocalEnv from './isLocalEnv';
export function isSeleniumRunning() {
  return document.cookie.includes('hs_selenium');
}
export function isJasmineRunning() {
  return window && 'jasmineRequire' in window;
}
export function isLocalWithoutSentryOverride() {
  try {
    return isLocalEnv() && localStorage.getItem('ENABLE_SENTRY') !== 'true';
  } catch (_unused) {
    // noop
  }
  return false;
}